module.exports = __webpack_public_path__ + "static/media/VGT_500.8c758f25.png";